/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color Converter — HEX, RGB & HSL | Toolverse`)
};

const es_cv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertidor de Color — HEX, RGB e HSL | Toolverse`)
};

const de_cv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbkonverter — HEX, RGB & HSL | Toolverse`)
};

const nl_cv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleurconverter — HEX, RGB & HSL | Toolverse`)
};

const fr_cv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertisseur de couleurs — HEX, RGB et HSL | Toolverse`)
};

const it_cv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertitore di colori — HEX, RGB e HSL | Toolverse`)
};

const pt_br2_cv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Cores — HEX, RGB e HSL | Toolverse`)
};

const pt_cv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversor de Cores — HEX, RGB e HSL | Toolverse`)
};

const ja_cv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`色変換ツール — HEX、RGB、HSL | Toolverse`)
};

const zh_cv_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`颜色转换器 — HEX、RGB与HSL | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cv_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cv_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cv_meta_title", locale)
	if (locale === "en") return en_cv_meta_title(inputs)
	if (locale === "es") return es_cv_meta_title(inputs)
	if (locale === "de") return de_cv_meta_title(inputs)
	if (locale === "nl") return nl_cv_meta_title(inputs)
	if (locale === "fr") return fr_cv_meta_title(inputs)
	if (locale === "it") return it_cv_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_cv_meta_title(inputs)
	if (locale === "pt") return pt_cv_meta_title(inputs)
	if (locale === "ja") return ja_cv_meta_title(inputs)
	return zh_cv_meta_title(inputs)
};